import { createSelector } from 'reselect';

// Types
import { RootState } from 'types/RootState.types';

// Config
import {
  getFormByIdSelector,
  getFormSyncErrorsSelector,
  getFormValuesSelector,
} from '@redux/reducers/form/formSelector';
import {
  getErrorMessage,
  validateGiftOptionsInputDataLength,
} from '@redux/reducers/payment/giftOptionsHigherOrderReducer';

const getErrorMessageSelector = (state: RootState, formId: string) => {
  const currForm = getFormByIdSelector(state, formId) ?? {};

  return getErrorMessage(formId, currForm);
};
const getErrorMessageIdSelector = (_state: RootState, formId: string) => `${formId}-error-message`;

const giftOptionsFormState = createSelector(
  [getErrorMessageSelector, getErrorMessageIdSelector, getFormSyncErrorsSelector, getFormValuesSelector],
  (errorMessage, errorMessageId, syncErrors, values) => {
    return {
      fullDataEntered: validateGiftOptionsInputDataLength(values),
      errorMessage,
      errorMessageId,
      formHasSyncErrors: !!syncErrors,
      values,
    };
  },
);

export default giftOptionsFormState;
